import ModalWindow from "components/ModalWindow";
import PagePopopCloseButton from "components/page-components/PagePopopCloseButton";
import icon from "assets/img/icons/success-green-big.svg";

const MultipleListingPopupSuccess = ({ close, selectedItems }) => {
  const getSum = () => {
    const total = selectedItems.reduce(
      (sum, item) => sum + Number(item.price),
      0
    );
    return total.toFixed(2);
  };

  return (
    <ModalWindow close={close}>
      <div
        className="modal-window__wrapper"
        onClick={(e) => e.stopPropagation()}
      >
        <PagePopopCloseButton close={close} />
        <>
          <header className="modal-window__header">
            <img src={icon} className="modal-window__icon" alt="" />
            <h5 className="modal-window__title">
              Your cards have been listed successfully!
            </h5>
            <p className="modal-window__info">
              Total number of cards listed: {selectedItems.length} <br />
              Total listing price: <span className="green">${getSum()}</span>{" "}
              <br />
              Total Marketplace Fee (5%):{" "}
              <span className="green">
                ${(getSum() * 0.05).toFixed(2)}
              </span>{" "}
              <br />
              Total net amount to seller:{" "}
              <span className="green">
                {" "}
                ${(getSum() - (getSum() * 0.05).toFixed(2))}{" "}
              </span>
            </p>
          </header>
          <footer className="modal-window__footer">
            <button className="modal-window__footer-submit" onClick={close}>
              Done
            </button>
          </footer>
        </>
      </div>
    </ModalWindow>
  );
};

export default MultipleListingPopupSuccess;
